module.exports = __webpack_public_path__ + "img/scorecard-3.94c489d3.jpg";